import React, { useState } from 'react';
import Card from './AppointmentCardStyles';
import rightArrow from '../../images/common/violet-arrow-right.svg';
import tooltipIcon from '../../images/common/tooltip.svg';
import { cardParams, LabelJSX, useImages } from './cardUtils';

import CardModal from './CardModal';

const DEFAULT_MODAL_DATA = { cardType: '', actionType: '' };
const AppointmentCard = ({
  pendingCopay,
  status,
  cancelCharge = 0,
  modalText,
  onTap = () => {},
  letter,
  onReload,
  tooltipText,
  ...props
}) => {
  const [modalData, setModalData] = useState(DEFAULT_MODAL_DATA);
  const [_, headerIcon] = useImages(undefined, status.cardType);
  const handleClick = (actionType) => {
    setModalData({ cardType: status.cardType, actionType });
  };

  return (
    <Card.Container
      style={
        status &&
        status.cardType &&
        !status.cardType.includes('appointment-reschedule')
          ? {
              border: 'none',
            }
          : {}
      }
    >
      <Card.Header onClick={onTap}>
        <Card.LogoContainer>
          {' '}
          <Card.Logo src={headerIcon} alt={status.title} />{' '}
        </Card.LogoContainer>
        <Card.TextContainer>
          <Card.Heading>
            {status.title}
            <Card.RightIcon src={rightArrow} />
          </Card.Heading>
          <Card.Subtitle> {status.description} </Card.Subtitle>
        </Card.TextContainer>
      </Card.Header>
      <Card.Body
        style={!status.questionText && !letter ? { borderBottom: 'none' } : {}}
      >
        {cardParams.map((item, ind) => (
          <React.Fragment key={item.name}>
            <Card.DataRow>
              <Card.DataIconContainer>
                <Card.DataIcon src={item.icon} alt={item.name} />
              </Card.DataIconContainer>
              <Card.DataColumn>
                <Card.DataTextContainer>
                  <Card.DataTextSubtitle>
                    {' '}
                    {item.name + (props[item.nameKey] || '')}{' '}
                  </Card.DataTextSubtitle>
                  <Card.DataTextSubContainer>
                    <Card.DataTextHeading
                      style={
                        ((item.value || '') +
                          (item.valueFormatter
                            ? item.valueFormatter(props[item.valueKey])
                            : props[item.valueKey]))[0] === 'A'
                          ? {
                              marginLeft: '1.5px',
                            }
                          : {}
                      }
                    >
                      {(item.value || '') +
                        (item.valueFormatter
                          ? item.valueFormatter(props[item.valueKey])
                          : props[item.valueKey])}
                      {Boolean(item.tooltipKey) ? (
                        <span>
                          <Card.DataIcon
                            id={`addressTooltip-${props.requestId}`}
                            data-tooltip-content={props[item.tooltipKey]}
                            style={{ marginLeft: '5px' }}
                            src={tooltipIcon}
                          />
                          {/* <Card.ToolTip
                            variant="info"
                            anchorId={`addressTooltip-${props.requestId}`}
                          /> */}
                        </span>
                      ) : (
                        <></>
                      )}
                      {item.valueKey === 'slotType' ? (
                        <span>
                          <Card.DataIcon
                            id={`slotTypeTooltip-${props.requestId}`}
                            data-tooltip-content={
                              props[item.valueKey] === 'walk-in'
                                ? 'Appointment will be held on first-come, first-served basis within the defined time slot.'
                                : 'Please reach the centre before your appointment time to avoid missing it'
                            }
                            style={{ marginLeft: '5px' }}
                            src={tooltipIcon}
                          />
                          <Card.ToolTip
                            variant="info"
                            anchorId={`slotTypeTooltip-${props.requestId}`}
                          />
                        </span>
                      ) : (
                        <></>
                      )}
                    </Card.DataTextHeading>

                    {pendingCopay && item.valueKey === 'doctorName' && false ? (
                      <Card.PriceContainer>
                        <Card.DataIcon
                          id={`doctorTooltip-${props.requestId}`}
                          data-tooltip-content={tooltipText}
                          src={tooltipIcon}
                        />
                        <Card.ToolTip
                          variant="info"
                          anchorId={`doctorTooltip-${props.requestId}`}
                        />
                        <Card.PriceText> {`₹ ${pendingCopay}`} </Card.PriceText>
                      </Card.PriceContainer>
                    ) : props[item.prevValueKey] &&
                      props[item.prevValueKey] !== props[item.valueKey] &&
                      props[item.newValueKey] ? (
                      <Card.DataTextSubtitleCancel>
                        <div>
                          <Card.DataIcon src={item.prevIcon} alt={item.name} />
                        </div>
                        <Card.DataTextSubtitleCancelText>
                          {item.valueFormatter
                            ? item.valueFormatter(props[item.prevValueKey])
                            : props[item.prevValueKey]}
                        </Card.DataTextSubtitleCancelText>
                      </Card.DataTextSubtitleCancel>
                    ) : (
                      <></>
                    )}
                  </Card.DataTextSubContainer>
                </Card.DataTextContainer>
              </Card.DataColumn>
            </Card.DataRow>
            {ind !== cardParams.length - 1 ? <Card.SpaceRow /> : <></>}
          </React.Fragment>
        ))}
        {status &&
        status.cardType &&
        !status.cardType.includes('appointment-reschedule') ? (
          <LabelJSX label={status.label} hex={status.hex} icon={status.icon} />
        ) : (
          <></>
        )}
      </Card.Body>
      {status.questionText ? (
        <>
          <Card.WarningText> {status.questionText} </Card.WarningText>
          <Card.ButtonGroup>
            <Card.ConfirmButton onClick={() => handleClick('confirm')}>
              Confirm {pendingCopay ? '& Pay' : ''}
            </Card.ConfirmButton>
            <Card.CancelButton onClick={() => handleClick('cancel')}>
              Cancel
              <span style={{ fontSize: '10px', color: '#767787' }}>
                {cancelCharge ? ` (₹ ${cancelCharge})` : ' (No Charges)'}
              </span>
            </Card.CancelButton>
          </Card.ButtonGroup>
        </>
      ) : (
        <></>
      )}
      {letter ? (
        <Card.ButtonGroup>
          <Card.ConfirmLink href={letter} target="_blank" download>
            View Cashless Letter
          </Card.ConfirmLink>
        </Card.ButtonGroup>
      ) : (
        <></>
      )}
      <CardModal
        {...modalData}
        requestId={props.requestId}
        onClose={() => setModalData(DEFAULT_MODAL_DATA)}
        onReload={onReload}
        cancelCharge={cancelCharge}
        modalText={modalText}
        pendingCopay={pendingCopay}
      />
    </Card.Container>
  );
};

export default AppointmentCard;
